import { ModalsStyleTokens } from "@omni/ui/brand/modals/modals.tokens";

export const ModalsStyles: ModalsStyleTokens = {
    confirmButton: {
        color: "primary"
    }
};
